import React from "react";
import {FIELD_TYPE, sortListFieldType} from "../../../Type/Model/Model";
import {STATUS_MODEL} from "../../../../../../enums/statusEnum";
import CustomUserChip from "../../../../../../components/CustomUserChip";
import {CloseIcon, WarningChip} from "../../../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import NotInformation from "../../../../../../components/NotInformation";
import {DocumentationFormRequestFormApp} from "../Functionality/DocumentationFormRequestFormApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const DocumentationFormRequestForm = ({
                                          getInvitationById, data, handleChange, emptyFields, t, photoPickerList,
                                          setPhotoPickerList,handleDeletePhotoPicker, isValidData
                                      }) => {

    const {
        guardFlowId,
        fieldsForm,
        fieldsFormDocument,
        fieldsFormCheckBox,
        handleCloseBadge,
        showBadgeMessage
    } = DocumentationFormRequestFormApp({photoPickerList, setPhotoPickerList, getInvitationById,handleDeletePhotoPicker});

    const fields = sortListFieldType(getInvitationById?.fields || []);

    return (
        <>
            {
                getInvitationById?.invitation?.statusId === STATUS_MODEL.CHANGES_REQUESTED &&
               (
                   showBadgeMessage &&
                   <div className={'mb-24px'}>
                       <CustomUserChip
                           className={'m-0 chip-warning-150-100 w-100 px-16px py-12px justify-content-start'}
                           name={t(guardFlowId ? 'guard_update_required_changes' : 'update_required_changes', { reason:getInvitationById?.invitation?.statusReason })}
                           Icon={WarningChip}
                           showAvatar={true}
                           classNameIcon="icon-color-warning-700"
                           variant='large'
                           iconPosition={POSITION_MODEL.LEFT}
                           onDelete={() => handleCloseBadge() }
                           deleteIcon={<CloseIcon fontSize='small' height={16} width={16} className="icon-color-warning-700"/>}
                       />
                   </div>
               )
            }

            {fields.length > 0 ? (
                <div className="row background-general-00 box-shadow-primary-900-opacity-10 p-24px border-radius-8px">
                    {fields.filter(field => field.fieldType !== FIELD_TYPE.DOCUMENT.name && field.fieldType !== FIELD_TYPE.CHECKBOX.name).map(field => (
                        <>
                            <div key={field.fieldId} className="col-12-sm col-lg-6 col-xl-6">
                                {fieldsForm(field, data, handleChange, emptyFields, isValidData)}
                            </div>

                        </>
                    ))}
                    <div className={"col-12"}/>
                    {fields.filter(field => field.fieldType === FIELD_TYPE.CHECKBOX.name).map(field => (
                        <>

                            <div key={field.fieldId} className="col-12">
                                {fieldsFormCheckBox(field, data, handleChange, emptyFields)}
                            </div>

                        </>
                    ))}
                    <div className={"col-12 mb-29px"}/>
                    {photoPickerList.map(field => (
                        <div key={field.fieldId} className="col-12-sm col-lg-6 col-xl-6">
                            {fieldsFormDocument(field, emptyFields)}
                        </div>
                    ))}
                </div>
            ) : (
                <NotInformation card={false} text={t('no_documentation')}/>
            )}
        </>
    );
};
export default DocumentationFormRequestForm
